/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     MyTraining page 
//   Details:    My Training page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103782 10/12/19 JC       New
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ItemsPage from '../components/ItemsPage';
import { itemCategories } from '../constants/ItemCategories';

class MyTraining extends Component {
	render() {
		return (
			<ItemsPage
				title="My Training"

				unreadTabText="Uncompleted"
				readTabText="Completed"

				unread={this.props.uncompleted}
                read={this.props.completed}

                unreadItemTypes={this.props.uncompletedItemTypes}
                readItemTypes={this.props.completedItemTypes}

                unreadItemCategory={this.props.uncompletedItemCategory}
                readItemCategory={this.props.completedItemCategory}
			/>
		);
	}
}

export default connect(
	state => ({
        uncompleted: state.uncompletedTraining,
        completed: state.completedTraining,

		uncompletedItemTypes: state.uncompletedTrainingTypes,
		completedItemTypes: state.completedTrainingTypes,

        uncompletedItemCategory: itemCategories.uncompletedTraining,
        completedItemCategory: itemCategories.completedTraining
	})
)(MyTraining);